
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetogoacab() {



    const cardData =
    {
        keyword: 'Pune To Goa Cab Booking',
        heading: 'Mauli Cabs: Pune To Goa Cab Booking',
        headingDescription: 'Mauli Cabs offers reliable and convenient Pune to Goa cab booking services, ensuring a smooth and enjoyable journey to the vibrant coastal paradise of Goa. Whether you are traveling for a beach vacation, a family trip, or a getaway with friends, we provide a range of vehicles including sedans, SUVs, and premium cars to match your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a comfortable and hassle-free ride from Pune to Goa.',

        top: 'Top Places to Visit in Goa with Mauli Cabs',

"topPlaces": [
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage site, the Basilica of Bom Jesus is one of the oldest churches in India. It is renowned for housing the mortal remains of St. Francis Xavier and is an architectural masterpiece of baroque style."
    },
    {
        "title": "Anjuna Beach",
        "description": "Anjuna Beach is famous for its vibrant nightlife, stunning sunsets, and beautiful beach parties. It's also known for its lively flea market, where visitors can shop for a variety of goods ranging from clothes to jewelry."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "Located on the Mandovi River, Dudhsagar Waterfalls is one of the tallest waterfalls in India. Surrounded by lush forests, it offers a picturesque view and is a popular spot for trekking and photography."
    },
    {
        "title": "Fort Aguada",
        "description": "Built by the Portuguese in the 17th century, Fort Aguada offers breathtaking views of the Arabian Sea. The fort also has a lighthouse and is a significant historical site in Goa."
    },
    {
        "title": "Palolem Beach",
        "description": "Known for its crescent-shaped beach, Palolem Beach is a peaceful getaway perfect for swimming, sunbathing, and kayaking. Its serene ambiance and beauty make it one of the most popular beaches in Goa."
    },
    {
        "title": "Se Cathedral",
        "description": "The Se Cathedral is one of the largest churches in Asia and is an important religious site in Goa. It is known for its stunning Portuguese-Gothic architecture and beautiful interior, making it a must-visit for architecture enthusiasts."
    },
    {
        "title": "Vasco da Gama",
        "description": "Named after the famous Portuguese explorer, Vasco da Gama is a vibrant town offering a mix of beaches, markets, and heritage sites. It is known for its colonial-style architecture and is a good base for exploring Goa."
    },
    {
        "title": "Colva Beach",
        "description": "Located in South Goa, Colva Beach is a long stretch of sandy shoreline surrounded by palm trees. It is perfect for leisurely walks, relaxing by the sea, or enjoying water sports like jet skiing and parasailing."
    },
    {
        "title": "Chapora Fort",
        "description": "Chapora Fort is a popular historical site in Goa, known for its strategic location and beautiful panoramic views of the Arabian Sea. It’s famously featured in Bollywood movies, including 'Dil Chahta Hai.'"
    },
    {
        "title": "The Fontainhas",
        "description": "Fontainhas is a charming Latin Quarter in Panjim, Goa. Known for its colorful Portuguese-style houses and narrow streets, it offers a glimpse into Goa's colonial past and is perfect for a walking tour."
    }
],

"services": [
    {
        "name": "Pune to Goa Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable taxi services for your journey from Pune to Goa. Enjoy a smooth and safe ride to one of the most popular holiday destinations in India."
    },
    {
        "name": "Book Pune to Goa Taxi",
        "description": "Book your Pune to Goa taxi with Mauli Cabs for a stress-free and enjoyable journey. We ensure timely and comfortable rides with a variety of vehicle options."
    },
    {
        "name": "Pune to Goa One-Way Cab",
        "description": "Mauli Cabs provides convenient one-way cab services from Pune to Goa. Choose a comfortable ride with professional drivers and enjoy a hassle-free one-way journey."
    },
    {
        "name": "Pune to Goa Round Trip",
        "description": "Opt for a round trip from Pune to Goa with Mauli Cabs. Enjoy a seamless travel experience with convenient pick-up and drop-off points for your round trip."
    },
    {
        "name": "Affordable Pune to Goa Cab",
        "description": "Mauli Cabs offers affordable and budget-friendly cab services for your Pune to Goa journey. Enjoy competitive pricing without compromising on comfort and quality."
    },
    {
        "name": "Luxury Cab from Pune to Goa",
        "description": "Travel in style with Mauli Cabs' luxury cab service from Pune to Goa. Enjoy premium vehicles and top-notch service for a high-end travel experience."
    },
    {
        "name": "Goa Trip by Cab from Pune",
        "description": "Plan your Goa trip with Mauli Cabs. We offer comfortable and reliable cab services for your journey from Pune to Goa, making your trip memorable and hassle-free."
    },
    {
        "name": "Private Cab Hire for Pune to Goa",
        "description": "Mauli Cabs offers private cab hire services from Pune to Goa. Travel with privacy and comfort with our well-maintained vehicles and experienced drivers."
    },
    {
        "name": "Pune to Goa Cab Booking Online",
        "description": "Book your Pune to Goa cab online with Mauli Cabs for easy, secure, and quick booking. Choose from a variety of vehicles to suit your needs and travel preferences."
    },
    {
        "name": "Group Travel to Goa in Pune Taxi",
        "description": "Travel with your group from Pune to Goa with Mauli Cabs. Our spacious vehicles are perfect for group travel, ensuring a comfortable and enjoyable ride for everyone."
    },
    {
        "name": "Pune to Goa Sightseeing Cab",
        "description": "Explore Goa with Mauli Cabs' sightseeing cab services. Our professional drivers will take you to the top attractions in Goa while ensuring a comfortable and enjoyable experience."
    }
],

"tableData": [
    ["Pune to Goa Cab Service", "Book Pune to Goa Taxi"],
    ["Pune to Goa One-Way Cab", "Pune to Goa Round Trip"],
    ["Affordable Pune to Goa Cab", "Luxury Cab from Pune to Goa"],
    ["Goa Trip by Cab from Pune", "Private Cab Hire for Pune to Goa"],
    ["Pune to Goa Cab Booking Online", "Group Travel to Goa in Pune Taxi"],
    ["Pune to Goa Sightseeing Cab", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for your Pune to Goa Cab Booking. Our drivers are committed to providing prompt pickups and drop-offs, ensuring you reach Goa on time for your vacation or business trip."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Goa trip, we offer a range of comfortable vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, spacious, and well-maintained, providing a smooth and relaxing ride along the scenic route to Goa."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Goa. They ensure a smooth, safe, and enjoyable journey, taking care of your comfort and safety along the way while also offering insightful tips about the trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Goa Cab Booking, with no hidden charges. We provide transparent pricing upfront, ensuring you get the best value for your money while traveling to Goa."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers strictly follow safety protocols, ensuring a secure and comfortable ride to Goa."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Goa Cab Booking. Whether you're planning an early morning start or a late-night return, our customer service team is always available to assist you with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Goa cab with Mauli Cabs is quick and simple. You can book your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance and seamless booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Goa journey. Whether you're planning a beach getaway, exploring Goa's vibrant culture, or visiting popular tourist spots, we can tailor the trip to suit your preferences and needs."
    }
]



















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Goa with Mauli Cabs?',
            answer: 'Booking your cab from Pune to Goa is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Goa as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our customer support team for booking assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Goa trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Goa, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your group size, comfort level, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Goa trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. You will receive the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Goa take?',
            answer: 'The journey from Pune to Goa typically takes around 8 to 9 hours, depending on traffic conditions. Our drivers ensure a smooth and comfortable journey, with breaks along the way for refreshments.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Goa route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Goa route and are familiar with the best routes to ensure a safe and timely journey. They prioritize your comfort and safety during the trip.',
        },
        {
            question: 'Can I book a round trip from Pune to Goa?',
            answer: 'Yes, you can easily book a round trip to Goa. Just provide your return details when making the booking, and we will ensure a smooth return journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Goa?',
            answer: 'Yes, you can customize your journey by making stops for sightseeing along the way. Whether you want to visit specific places or simply take a break, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride during your journey to Goa.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Goa trip?',
            answer: 'Mauli Cabs offers reliable and professional service, competitive pricing, a wide range of vehicle options, and experienced drivers. We ensure that your trip to Goa is comfortable, safe, and enjoyable, whether it’s for a vacation, business trip, or special occasion.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Amit Kumar",
            position: "Holiday Traveler",
            text: "My journey from Pune to Goa with Mauli Cabs was fantastic! The vehicle was comfortable and clean, and the driver was very professional. The trip was smooth, and I could enjoy the scenic route. I would definitely book with Mauli Cabs for my next trip to Goa!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Sharma",
            position: "Vacation Traveler",
            text: "I had a wonderful experience with Mauli Cabs on my trip to Goa. The ride was extremely comfortable, and the driver was friendly and knowledgeable about the best routes. I highly recommend Mauli Cabs for anyone planning a trip to Goa!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Goa Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Goa. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Goa with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Goa Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Goa cab with Mauli Cabs. Choose from affordable, luxury, private, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Goa cab service, Book Pune to Goa taxi, Pune to Goa one-way cab, Pune to Goa round trip, Affordable Pune to Goa cab, Luxury cab from Pune to Goa, Goa trip by cab from Pune, Private cab hire for Pune to Goa, Pune to Goa cab booking online, Group travel to Goa in Pune taxi, Pune to Goa sightseeing cab"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoacab;